import React, { useState } from 'react';
import { CheckIcon } from '@heroicons/react/20/solid';
import { Combobox } from '@headlessui/react';
import { useQuery } from '@apollo/client';
import preAuth from '../../../../gql/preAuth';
import { Tooltip } from '@mui/material';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

function MorphologySearch({ setFieldValue, values }) {
  const [query, setQuery] = useState('');
  const [selectedMorphology, setSelectedMorphology] = useState(null);

  const [codes, setCodes] = useState([]);
  const formatData = data => {
    return (
      data?.map(item => ({
        id: item.code,
        name: item.display,
        Code: item.code,
        Display: item.display
      })) || []
    );
  };

  const { loading, error, data, refetch } = useQuery(preAuth.GET_SEARCHED_MORPHOLOGY, {
    variables: { q: '' }
  });

  React.useEffect(() => {
    if (data) {
      setCodes(formatData(data.getMorphologyCodes?.data));
    }
  }, [data]);

  const filteredCodes =
    query === ''
      ? codes
      : codes.filter(code => {
          const lowerCaseQuery = query.toLowerCase();
          return code.name.toLowerCase().includes(lowerCaseQuery) || code.id.toLowerCase().includes(lowerCaseQuery);
        });

  const onSearch = inputText => {
    setQuery(inputText);
    if (inputText.length > 2) {
      refetch({ q: inputText });
    }
  };

  return (
    <Combobox
      as='div'
      value={selectedMorphology}
      onChange={val => {
        setSelectedMorphology(val);
        setFieldValue(val);
      }}
    >
      <div className='relative'>
        {values?.code || values?.codeText ? (
          <Tooltip title={values?.codeText ? values.codeText + ' - ' + values?.code : ''}>
            <div className='text-sm font-light'>
              {values?.codeText ? values.codeText.slice(0, 25) + '...' + ' - ' + values?.code : ''}
            </div>
          </Tooltip>
        ) : null}

        <Combobox.Input
          className='insurance-plans-select'
          onChange={event => onSearch(event.target.value)}
          displayValue={code => code?.name}
          placeholder={'Search for Morphology Code'}
        />
        {filteredCodes.length > 0 && (
          <Combobox.Options className='absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm'>
            {filteredCodes.map(code => (
              <Combobox.Option
                key={code.id}
                value={code}
                className={({ active }) =>
                  classNames(
                    'relative cursor-default select-none py-2 pl-3 pr-9',
                    active ? 'bg-amber-600 text-white' : 'text-gray-900'
                  )
                }
              >
                {({ active, selected }) => (
                  <>
                    <span className={classNames('block truncate', selected && 'font-semibold')}>
                      {code.name} - {code.id}
                    </span>
                    {selected && (
                      <span
                        className={classNames(
                          'absolute inset-y-0 right-0 flex items-center pr-4',
                          active ? 'text-white' : 'text-amber-600'
                        )}
                      >
                        <CheckIcon className='h-5 w-5' aria-hidden='true' />
                      </span>
                    )}
                  </>
                )}
              </Combobox.Option>
            ))}
          </Combobox.Options>
        )}
      </div>
    </Combobox>
  );
}

export default MorphologySearch;
